<adapt-feature-guidance [configItem]="configItem">
    <p>Configure how this group looks across the platform. Set the group's icon and colours.</p>
</adapt-feature-guidance>

<adapt-feature-configuration [team]="team"
                             [configItem]="configItem">
    <adapt-team-display-configuration [entity]="team"
                                      (configureOrganisationGroupTypesClicked)="onConfigureOrganisationGroupTypesClicked()"></adapt-team-display-configuration>
</adapt-feature-configuration>
